export default "__VITE_ASSET__4764f51b__"